import React, { Fragment } from 'react';
import Navbar from '../../components/Navbar/Navbar';
import PageTitle from '../../components/pagetitle/PageTitle'
import Scrollbar from '../../components/scrollbar/scrollbar'
import { useParams } from 'react-router-dom'
import Project from '../../api/Projects';
import Footer from '../../components/footer/Footer';

const ProjectSinglePage = (props) => {
    const { slug } = useParams()

    const projectDetails = Project.find(item => item.slug === slug)

    return (
        <Fragment>
            <Navbar />
            <PageTitle pageTitle={projectDetails.pTitle} pagesub={'Project'} />
            <div className="project-single-area section-padding">
                {projectDetails?.content}
            </div>
            <Footer/>
            <Scrollbar />
        </Fragment>
    )
};
export default ProjectSinglePage;
